import { render, staticRenderFns } from "./PaymentsPage.vue?vue&type=template&id=b0cf5856&scoped=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentsPage.vue?vue&type=style&index=0&id=b0cf5856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cf5856",
  null
  
)

export default component.exports